const parseTimeOfDay = (time: string, base: Date): Date => {
  const [h, m, s] = time.split(':').map(Number);
  const d = new Date(base);
  d.setHours(h, m || 0, s || 0, 0);
  return d;
};

const addDays = (date: Date, days: number): Date => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

/**
 * Resolves a branch's HH:mm:ss working-hours pair into the open window
 * (start/end Dates) that is either active right now or comes next.
 * Handles hours that cross midnight (e.g. 08:00 -> 03:00).
 */
export const getActiveWorkWindow = (
  now: Date,
  workTimeFrom?: string | null,
  workTimeTo?: string | null
): { start: Date; end: Date } | null => {
  if (!workTimeFrom || !workTimeTo) return null;

  const todayStart = parseTimeOfDay(workTimeFrom, now);
  const todayEnd = parseTimeOfDay(workTimeTo, now);
  const crossesMidnight = todayEnd <= todayStart;

  if (!crossesMidnight) {
    if (now <= todayEnd) return { start: todayStart, end: todayEnd };
    // Closed for the rest of today — the next window opens tomorrow.
    return { start: addDays(todayStart, 1), end: addDays(todayEnd, 1) };
  }

  // Hours cross midnight: today's close time is the tail of yesterday's window.
  if (now < todayEnd) {
    return { start: addDays(todayStart, -1), end: todayEnd };
  }
  // Whether we're still waiting for today's opening or already past it, the
  // relevant window is the one that opens today and closes tomorrow.
  return { start: todayStart, end: addDays(todayEnd, 1) };
};
